import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getProfile } from "./api";
import { UserProfile } from "./types";

// Query keys
export const PROFILE_QUERY_KEY = ["userProfile"] as const;

// Query Settings
export const profileQuerySettings = {
  queryKey: PROFILE_QUERY_KEY,
  queryFn: () => getProfile(),
  staleTime: 5 * 60 * 1000, // 5 minutes
};

/**
 * Hook to fetch the current user's profile
 * @param options Optional query options
 * @returns Query result with user profile
 */
export function useProfile(
  options: Omit<UseQueryOptions<UserProfile>, "queryKey" | "queryFn"> = {},
) {
  return useQuery<UserProfile>({ ...profileQuerySettings, ...options });
}

/**
 * Hook to get the organization ID from the user profile
 * @param options Optional query options
 * @returns Object with organizationId and loading state
 */
export function useProfileOrganizationId(
  options: Omit<UseQueryOptions<UserProfile>, "queryKey" | "queryFn"> = {},
) {
  const { data: profile, isLoading } = useProfile(options);
  return { organizationId: profile?.organization.id, isLoading };
}
